// 类型
export const AskMethodType = {
    // 一键问诊
    NORMAL: 1,
    // 图文问诊
    IMAGE: 14,
    // 视频问诊
    VIDEO: 15,
	// 线下门诊
	STORE: 16,
	// 图文问诊
	PHONE: 14  //17
}